export const setLanguagePack = (languagePack = []) => ({
    type: 'SET_LANGUAGE_PACK',
    languagePack: {...languagePack}
})

export const setEntertainment = (entertaiment = []) => ({
    type: 'SET_ENTERTAIMENT_LIST',
    ...entertaiment
})

export const setProjects = (data = []) => ({
    type: 'SET_PROJECT_LIST',
    data: {...data}
})



// WEBPACK FOOTER //
// ./src/actions/redux.js